import EnterpriseSectionManagement from "@/components/domains/enterprise/dto/enterpriseSectionManagement";

export default class EnterpriseSection {
    public sectionId = "";
    public sectionName = "";
    public statusCode = "";
    public managements: EnterpriseSectionManagement[] = [];
}